import Shared from '../shared.module.css';
import React, { useState, useEffect } from 'react';
import { IoPeopleOutline } from 'react-icons/io5';
import { collection, getFirestore, onSnapshot, query, where } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import StaffProfileMake, { StaffEditing } from './make/index';
import StaffCard from './Card';
import Setting from '../../8.setting/index';

// 元 12.staffProfiles/index.tsx から移動。Firestore取得ロジックは変更していない
// (staffProfilesコレクションをcompanyIdで絞り込み、created_at降順で並べる)。
// 追加モーダルの開閉状態は、以前はシェル(desktop/index.tsx)のヘッダーボタンが
// 持っていたが、タブ内に「＋」ボタンを持つ構成に変わったためこのタブ内に移した。
const StaffTab: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);

  const [ staffList, setStaffList ] = useState<any[]>([]);
  const [ make, setMake ] = useState(false);
  // 「編集する」で開いているスタッフ
  const [ editing, setEditing ] = useState<StaffEditing | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const db = getFirestore();
    const queryRef = query(
      collection(db, 'staffProfiles'),
      where('companyId', '==', company.id)
    );

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const tmp: any[] = snapshot.docs.map((doc) => ({
        id: doc.id,
        docId: doc.data().docId,
        name: doc.data().name,
        position: doc.data().position ?? '',
        message: doc.data().message,
        instagramId: doc.data().instagramId,
        tiktokId: doc.data().tiktokId,
        created_at: doc.data().created_at?.toDate ? doc.data().created_at.toDate() : new Date(doc.data().created_at),
      }));
      tmp.sort((a, b) => b.created_at - a.created_at);
      setStaffList(tmp);
    });

    return () => unsub();
  }, [ company.id ]);

  // 元のルーティングでは company.contract が false の場合 <Setting /> にフォール
  // バックしていた(権限処理は変更しない)。
  if (!company.contract) {
    return <Setting />;
  }

  return (
    <>
      <div className={Shared.tabHeader}>
        <div>
          <h3 className={Shared.tabHeaderTitle}>スタッフプロフィール</h3>
          <p className={Shared.tabHeaderDesc}>スタッフの情報を登録し、学生にアピールできます。</p>
        </div>
        {staffList.length > 0 && (
          <button type="button" className={Shared.addButton} onClick={() => setMake(true)}>＋ スタッフを追加する</button>
        )}
      </div>

      {staffList.length === 0 ? (
        <div className={Shared.emptyState}>
          <div className={Shared.emptyStateIcon}><IoPeopleOutline /></div>
          <p className={Shared.emptyStateTitle}>まだスタッフが登録されていません</p>
          <p className={Shared.emptyStateDesc}>スタッフの情報を登録すると、学生にサロンの雰囲気を伝えられます。</p>
          <button type="button" className={Shared.addButton} onClick={() => setMake(true)}>＋ スタッフを追加する</button>
        </div>
      ) : (
        <div className={Shared.cardGrid}>
          {staffList.map((data) => (
            <StaffCard key={data.id} staff={data} onEdit={() => setEditing(data)} />
          ))}
        </div>
      )}

      {make ? <StaffProfileMake setMake={setMake} companyId={company.id} /> : <></> }
      {editing && <StaffProfileMake key={editing.id} setMake={() => setEditing(null)} companyId={company.id} editing={editing} />}
    </>
  );
};

export default StaffTab;
